import { ref } from 'vue';
import { useGameDash } from '/app/composables/gamedash';
import { usePreference } from '/app/composables/preferences';

// Shared by the navbar bell badge and the inline widget's dot, so seeing the
// updates on either surface clears both.
const hasUpdates = ref(false);

/**
 * Unseen Game Dash activity. The navbar Dialog owns raising it (score diff and
 * real-time pushes); any surface that shows the dash calls `markSeen` when it
 * opens.
 */
export function useGameDashUpdates() {
    const { brain, role } = useGameDash();
    const { model: score } = usePreference({ scope: 'user', path: 'gamedash.shared_state.gamedash_score' });

    const markUnread = () => {
        hasUpdates.value = true;
    };

    const markSeen = () => {
        hasUpdates.value = false;

        if (role.value !== 'overall') {
            return;
        }

        // Seen: the badge stays off until the score moves past this.
        if (brain.value?.score && score.value !== brain.value.score) {
            score.value = brain.value.score;
        }
    };

    return { hasUpdates, score, markUnread, markSeen };
}
